(ns teamoesterreich.admin-mode.crowdtasker.event-region
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [goog.json :as json]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.event :as d-event]
            [teamoesterreich.admin-mode.map.map-polygon-picker :as map-polygon-picker]


            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]

            [clojure.string :as string]))

(defn un-serialize-path [in]
  (json/parse in))


(defn radio [name !radio]
  [mui/form-control-label {:label   name :value "dst" :placement "start"
                           :control (r/as-element [mui/radio {:checked  @!radio
                                                              :onChange (fn [val])
                                                              }])}]

  )



(defn region-selector [disabled]
  (let [!st (r/atom {:region-type nil :path #js [] :district nil :state nil})
        !edit-mode (r/cursor !st [:edit-mode])
        !event (r/cursor vstate/app-state [:selected-event])
        !region-type (r/cursor !st [:region-type])
        !district (r/cursor !st [:district])
        !state (r/cursor !st [:state])
        !path (r/cursor !st [:path])]
    (fn []
      (let [

            reset-fn (fn [] (reset! !st {:region-type nil :path #js [] :district nil :state nil}))

            initial-path (when (and (:crowdtaskerEvent-locationPolygonJsonString @!event) (not= (:crowdtaskerEvent-locationPolygonJsonString @!event) ""))
                           (un-serialize-path (:crowdtaskerEvent-locationPolygonJsonString @!event)))

            g-state (:crowdtaskerEvent-locationState @!event)
            g-district (:crowdtaskerEvent-locationDistrict @!event)

            g-type (cond
                     (and initial-path (not= "" initial-path)) :polygon
                     (and g-district (not= "" g-district)) :district
                     (and g-state (not= "" g-state)) :state
                     :else :none)
            changed? (or (and @!region-type (not= g-type @!region-type))
                         (and @!district (not= g-district @!district))
                         (and @!state (not= g-state @!state)))
            ]
        [mui/paper
         {:style {:textAlign "left" :padding "10px"}}
         [mui/form-control {:component "fieldset"}
          [mui/radio-group {:row      true
                            :style    {:float "left" :padding "10px" :backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                            :value    (or @!region-type g-type)
                            :onChange (fn [e] (reset! !region-type (keyword (h/event-value e))))
                            }
           [mui/form-control-label
            {:value   :none
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Keine Region")
             }
            ]
           [mui/form-control-label
            {:value   :state
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Kreis")
             }
            ]
           [mui/form-control-label
            {:value   :district
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Gemeinde")
             }
            ]
           [mui/form-control-label
            {:value   :polygon
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Polygon")
             }
            ]

           ]]

         [:br]
         (case (or @!region-type g-type)
           :none [:div {:style {:padding "7px 0 7px 0"}}
                  [mui/chip {:label "Keine Regions-Eingrenzung"}]
                  [:br] [:br]
                  (when (and (not @!edit-mode) (not disabled))
                    [mui/button {
                                 :variant   "contained"
                                 :startIcon (r/as-element [edit])
                                 :onClick   #(reset! !edit-mode true)
                                 } "Bearbeiten"])

                  (when (and (not @!edit-mode) disabled (d-rights/is-superuser?))
                    [mui/button {
                                 :variant   "outlined"
                                 :style     {:color "orange"}
                                 :startIcon (r/as-element [edit])
                                 :onClick   #(reset! !edit-mode true)
                                 } "Bearbeiten (superuser)"])

                  (when @!edit-mode
                    [mui/button {:variant   "contained"
                                 :startIcon (r/as-element [keyboard-arrow-left])
                                 :onClick   reset-fn
                                 } "Abbrechen"])
                  (when @!edit-mode
                    [mui/button {:variant   "contained"
                                 :style     {:marginLeft "20px"}
                                 :disabled  (if changed? false true)
                                 :color     "primary"
                                 :onClick   (fn [] (d-event/>event-save-county-state (:crowdtaskerEvent-uuid @!event) nil nil))
                                 :startIcon (r/as-element [save])}
                     "Speichern"])
                  ]

           :polygon [:div {:style {:padding "7px 0 7px 0"}}
                     [map-polygon-picker/pick-polygon-gmap-component !st initial-path @!edit-mode]
                     ;[map-polygon-picker/pick-polygon-test]
                     [:br] [:br]

                     (when (and (not @!edit-mode) (not disabled))
                       [mui/button {
                                    :variant   "contained"
                                    :startIcon (r/as-element [edit])
                                    :onClick   #(reset! !edit-mode true)
                                    } "Bearbeiten"])

                     (when (and (not @!edit-mode) disabled (d-rights/is-superuser?))
                       [mui/button {
                                    :variant   "outlined"
                                    :style     {:color "orange"}
                                    :startIcon (r/as-element [edit])
                                    :onClick   #(reset! !edit-mode true)
                                    } "Bearbeiten (superuser)"])

                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :startIcon (r/as-element [keyboard-arrow-left])
                                    :onClick   reset-fn
                                    } "Abbrechen"])
                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :startIcon (r/as-element [edit])
                                    :style     {:marginLeft "20px"}
                                    :onClick   #(swap! !st assoc :pickMode true :path #js [])
                                    } "Polygon beginnen"])
                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :style     {:marginLeft "20px"}
                                    :color     "primary"
                                    :onClick   (fn []
                                                 (when (> (count (:path @!st)) 2)
                                                   (d-event/>event-save-polygon (:crowdtaskerEvent-uuid @!event) @!path)))
                                    :startIcon (r/as-element [save])}
                        "Speichern"])
                     ]


           :state [:div {:style {:padding "7px 0 7px 0"}}
                   [:br]
                   [mui/form-control
                    {
                     :fullWidth true
                     }
                    [mui/input-label "Bezirk"]

                    [mui/select {:style    {:width "300px" :backgroundColor (if (and @!state (not= g-state @!state)) "#ffd6d2" "#ffffff")}
                                 :value    (or @!state g-state)
                                 :disabled (not @!edit-mode)
                                 :onChange (fn [e] (reset! !state (h/event-value e)))
                                 }
                     (for [[k v] (sort-by first (txt/txt :fake :districts))]
                       ^{:key (str "DISTRICT-" k)} [mui/menu-item {:key (str "" k) :value k} v])
                     ]
                    ]
                   [:br]
                   [:br]
                   (when (and (not @!edit-mode) (not disabled))
                     [mui/button {
                                  :variant   "contained"
                                  :startIcon (r/as-element [edit])
                                  :onClick   #(reset! !edit-mode true)
                                  } "Bearbeiten"])

                   (when (and (not @!edit-mode) disabled (d-rights/is-superuser?))
                     [mui/button {
                                  :variant   "outlined"
                                  :style     {:color "orange"}
                                  :startIcon (r/as-element [edit])
                                  :onClick   #(reset! !edit-mode true)
                                  } "Bearbeiten (superuser)"])

                   (when @!edit-mode
                     [mui/button {:variant   "contained"
                                  :startIcon (r/as-element [keyboard-arrow-left])
                                  :onClick   reset-fn
                                  } "Abbrechen"])
                   (when @!edit-mode
                     [mui/button {:variant   "contained"
                                  :style     {:marginLeft "20px"}
                                  :color     "primary"
                                  :disabled  (if changed? false true)
                                  :onClick   (fn [] (d-event/>event-save-county-state (:crowdtaskerEvent-uuid @!event) @!state nil))
                                  :startIcon (r/as-element [save])}
                      "Speichern"])
                   ]

           :district [:div {:style {:padding "7px 0 7px 0"}}
                      [:br]
                      [mui/form-control
                       {
                        :fullWidth false
                        }
                       [mui/input-label "Bezirk"]

                       [mui/select {:style     {:width "300px" :backgroundColor (if (and @!state (not= g-state @!state)) "#ffd6d2" "#ffffff")}
                                    :fullWidth false
                                    :disabled  (not @!edit-mode)
                                    :value     (str (or @!state g-state ""))
                                    :onChange  (fn [e] (reset! !state (h/event-value e)))
                                    }
                        (for [[k v] (sort-by first (txt/txt :fake :districts))]
                          ^{:key (str "DISTRICT-" k)} [mui/menu-item {:key (str "" k) :value k} v])
                        ]
                       ]
                      (when (or @!state g-state)
                        [mui/form-control
                         {:style     {:marginLeft "30px"}
                          :fullWidth false
                          }
                         [mui/input-label "Kreis"]

                         [mui/select {:style     {:width "300px" :backgroundColor (if (and @!state (not= g-district @!district)) "#ffd6d2" "#ffffff")}
                                      :fullWidth false
                                      :disabled  (not @!edit-mode)
                                      :value     (str (or @!district g-district))
                                      :onChange  (fn [e] (reset! !district (h/event-value e)))
                                      }
                          (for [[k v] (filter
                                        #(string/starts-with? (first %) (or @!state g-state))
                                        (sort-by first (txt/txt :fake :county)))]
                            ^{:key (str "COUNTY-" k)} [mui/menu-item {:key (str "" k) :value k} v])
                          ]

                         ])
                      [:br]
                      [:br]
                      (when (and (not @!edit-mode) (not disabled))
                        [mui/button {
                                     :variant   "contained"
                                     :startIcon (r/as-element [edit])
                                     :onClick   #(reset! !edit-mode true)
                                     } "Bearbeiten"])

                      (when (and (not @!edit-mode) disabled (d-rights/is-superuser?))
                        [mui/button {
                                     :variant   "outlined"
                                     :style     {:color "orange"}
                                     :startIcon (r/as-element [edit])
                                     :onClick   #(reset! !edit-mode true)
                                     } "Bearbeiten (superuser)"])
                      (when @!edit-mode
                        [mui/button {:variant   "contained"
                                     :startIcon (r/as-element [keyboard-arrow-left])
                                     :onClick   reset-fn
                                     } "Abbrechen"])
                      (when @!edit-mode
                        [mui/button {:variant   "contained"
                                     :style     {:marginLeft "20px"}
                                     :color     "primary"
                                     :disabled  (if changed? false true)
                                     :onClick   (fn [] (d-event/>event-save-county-state (:crowdtaskerEvent-uuid @!event) @!state @!district))
                                     :startIcon (r/as-element [save])}
                         "Speichern"])
                      ]
           ""
           )
         ]

        ))))












































